module.exports = __webpack_public_path__ + "static/media/map-location.987110c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/OrganizationalUnit/map-location.svg
// module id = 2419
// module chunks = 0